export default __webpack_public_path__ + "static/media/xcovers-4-lqMAX.66e950a9.jpg";